<template>
  <v-tab-item :id="name">
    <slot></slot>
  </v-tab-item>
</template>

<script>
export default {
  name: 'AscTabItem',

  props: {
    name: {
      type: String,
      default: undefined,
    },
  },
}
</script>
